import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Popover from '@material-ui/core/Popover';
import { Link, withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CircularProgress } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert/Alert';
import Tooltip from '@material-ui/core/Tooltip';
import { getNextPhysicianData } from '../common/api-utils';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import {deletePhysician} from '../common/apicall/physician';
import Snackbar from '@material-ui/core/Snackbar';

const StyledTableCell = withStyles(() => ({
    head: {
        backgroundColor: '#fff',
        color: '#151515',
        fontWeight: '600',
        lineHeight: '1.2',
        padding: '5px 16px',
        fontSize: '18px',
    },
    body: {
        fontSize: 18,
        fontWeight: '500',
    },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F8F8F8',
        },
    },
}))(TableRow);

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

class ClientListsDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pop_open: false,
            pop_chart_open: false,
            currentcontactItem: {},
            physicianData: [],
            anchorEl: null,
            anchorElMenu: null,
            openMenu: false,
            currentSelectedPhysician: undefined,
            number: 5,
            openMessageDialog: false,
            openPopup: false,
        };
    }

  handleContactClick = (event, physician) => {
      this.setState({
          anchorEl: event.currentTarget,
          pop_open: !this.state.pop_open,
          currentcontactItem: physician,
      });
  };
  handleClose = () => {
      this.setState({
          pop_open: false,
          pop_chart_open: false,
      });
  };

  handlePopupClose = () => {
      this.setState({ openPopup: false });
  };

  handleMenuClose = () => {
      this.setState({ anchorElMenu: null });
  };

  loadNextData = async () => {
      const { centralStore } = this.props;
      let key = JSON.parse(localStorage.getItem('lastphysicianevaluatedkey'));
      if (key) {
          console.log('103',key);
          centralStore.setHasMore(false);
      } else {
          centralStore.setHasMore(true);
          getNextPhysicianData();
      }
  };

  handleMessageDialogOpen = (event, physician) => {
      const { centralStore } = this.props;

      centralStore.setSelectedphysicianData(physician);
      centralStore.openMessageDialog();
      console.log('openMessageDialogValue', centralStore.openMessageDialogValue);
  };
  handleMessageDialogClose = () => {
      const { centralStore } = this.props;
      centralStore.closeMessageDialog();
  };

  splitFirstLastName = (name) => {
      let firstName = name ? name.split(' ')[0] : '';
      let lastName = name ? name.split(' ')[1] : '';
      return `${lastName}, ${firstName}`;
  };

  handleRemovePhysician = (event,physician) => {
      event.preventDefault();
      const { centralStore } = this.props;
      this.setState({ openPopup: true });
      this.setState({ successMessage: 'Physician Removed Successfully!' });
     
      window.location.reload();
  
      let physicianData = {
          emailId:physician.emailId
      };
      deletePhysician(physicianData).then((response) => {
          console.log('Delete Resp', response);
          centralStore.hideLoader();
      });
  };

  render() {
      const { centralStore } = this.props;
      let physicianDataTable = centralStore.physicianTableDataValue || [];
      return (
          <>
              <Grid container className="table-grid-container">
                  <Grid item xs={12}>
                      <Paper className="shadow-box">
                          <Box p={2} className="box-heading">
                              <Typography variant="h4">Client Details</Typography>
                          </Box>
                          <TableContainer id="scrollableDiv" className="table-height">
                              <InfiniteScroll
                                  dataLength={physicianDataTable.length}
                                  next={this.loadNextData}
                                  hasMore={centralStore.currentHasMoreValue}
                                  loader={
                                      <Box
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="center"
                                      >
                                          <CircularProgress className="loading-more-record" />
                    Loading More Records...
                                      </Box>
                                  }
                                  endMessage={
                                      <Box
                                          display="flex"
                                          flexDirection="column"
                                          alignItems="center"
                                          marginTop={2}
                                          marginBottom={2}
                                      >
                                          <Alert severity="info">
                                              {physicianDataTable.length
                                                  ? 'All ' +
                        physicianDataTable.length +
                        ' Records Fetched...!'
                                                  : 'No Records To Display...!'}
                                          </Alert>
                                      </Box>
                                  }
                                  scrollableTarget="scrollableDiv"
                              >
                                  <Table
                                      stickyHeader
                                      className="patient-tbl"
                                      aria-label="sticky table"
                                      size="small"
                                  >
                                      <TableHead>
                                          <TableRow>
                                              <StyledTableCell>Client Name</StyledTableCell>
                                              <StyledTableCell align="center">Speciality</StyledTableCell>
                                              <StyledTableCell align="center">Role</StyledTableCell>
                                              <StyledTableCell align="center">Email</StyledTableCell>
                                              <StyledTableCell align="center">Phone</StyledTableCell>
                                              <StyledTableCell align="center">Age</StyledTableCell>
                                              <StyledTableCell align="center">Address</StyledTableCell>
                                              <StyledTableCell align="center">Remove</StyledTableCell>
                                          </TableRow>
                                      </TableHead>
                                      <TableBody>
                                          <StyledTableRow className="hint-row">
                                              <StyledTableCell>Last Name, First Name</StyledTableCell>
                                              <StyledTableCell align="center">Speciality</StyledTableCell>
                                              <StyledTableCell align="center">Role</StyledTableCell>
                                              <StyledTableCell align="center">Email</StyledTableCell>
                                              <StyledTableCell align="center">1(805) 123-4567 </StyledTableCell>
                                              <StyledTableCell align="center">Years</StyledTableCell>
                                              <StyledTableCell align="center">Address</StyledTableCell>
                                              <StyledTableCell align="center">Remove</StyledTableCell>
                                          </StyledTableRow>

                                          {physicianDataTable.map((physician, index) => {
                                              return (
                                                  <StyledTableRow key={index}>
                                                      <StyledTableCell>
                                                          <Link
                                                              onContextMenu={async (event) => {
                                                                  event.preventDefault();
                                                                  this.setState({
                                                                      anchorElMenu: event.currentTarget,
                                                                      currentSelectedPhysician: physician,
                                                                  });
                                                              }}
                                                              onClick={() => {
                                                                  localStorage.setItem(
                                                                      'physician_id',
                                                                      physician.physician_id
                                                                  );
                                                              }}
                                                              to="#"
                                                          >
                                                              {physician.lastName + ', ' + physician.firstName}
                                                          </Link>
                                                      </StyledTableCell>
                         
                                                 
                                                      <LightTooltip  title={
                                                          <React.Fragment>
                                                              {'Speciality'}
                                                          </React.Fragment>
                                                      }placement="top">
                                                          <StyledTableCell align="center">
                                                              {physician.speciality}
                                                          </StyledTableCell>
                                                      </LightTooltip>

                                                      <LightTooltip  title={
                                                          <React.Fragment>
                                                              {'Role'}
                                                          </React.Fragment>
                                                      }placement="top">
                                                          <StyledTableCell align="center">
                                                              {physician.role}
                                                          </StyledTableCell>
                                                      </LightTooltip>

                                                      <LightTooltip  title={
                                                          <React.Fragment>
                                                              {'Email'}
                                                          </React.Fragment>
                                                      }placement="top">
                                                          <StyledTableCell align="center">
                                                              {physician.email}
                                                          </StyledTableCell>
                                                      </LightTooltip>

                                                  
                                                      <StyledTableCell align="center">
                                                          {physician.phone}
                                                      </StyledTableCell>
                                                  
                                                 
                                                      <StyledTableCell align="center">
                                                          {physician.age}
                                                      </StyledTableCell>
                                                 
                                                      <LightTooltip  title={
                                                          <React.Fragment>
                                                              {'Address'}
                                                          </React.Fragment>
                                                      }placement="top">
                   
                                                          <StyledTableCell align="center">
                                                              {physician.address}
                                                          </StyledTableCell>
                                                      </LightTooltip>
                                                  
                                                      <LightTooltip  title={
                                                          <React.Fragment>
                                                              {'Remove'}
                                                          </React.Fragment>
                                                      }placement="top">
                                                          <StyledTableCell align="center">
                                                              <Button
                                                                  onClick={(event) => {
                                                                      this.handleRemovePhysician(event,physician);
                                                                      centralStore.showLoader();
                                                                  }}
                                                              //   className="icon-remove"
                                                              >
                                                                  <DeleteIcon />
                                                              </Button>{' '}
                                                          </StyledTableCell>
                                                      </LightTooltip>
                         
                                                  </StyledTableRow>
                        
                                              );
                                          })
                                          }
                                          <Menu
                                              id="simple-menu"
                                              anchorEl={this.state.anchorElMenu}
                                              keepMounted
                                              open={Boolean(this.state.anchorElMenu)}
                                              onClose={this.handleMenuClose}
                                          >
                                              {/* <MenuItem
                                              onClick={() => {
                                                  this.handleMenuClose();
                                                  localStorage.setItem(
                                                      'physician_id',
                                                      this.state.currentSelectedPhysician.physician_id
                                                  );
                                                  this.props.history.push('/physiciandashboard');
                                              }}
                                          >
                        View physician Dashboard
                                          </MenuItem> */}
                                              <MenuItem
                                                  onClick={async () => {
                                                      this.handleMenuClose();
                                                      centralStore.showAddEditDialog();
                                                      centralStore.setPhysicianDataForEdit(
                                                          this.state.currentSelectedPhysician
                                                      );
                                                  }}
                                              >
                        Edit Client Details
                                              </MenuItem>
                                          </Menu>

                                          {/* //////////////// ====================POPUPS==========////////////// */}
                                          <Popover
                                              open={this.state.pop_open}
                                              anchorEl={this.state.anchorEl}
                                              onClose={this.handleClose}
                                              className="contact-popover-outer"
                                              anchorOrigin={{
                                                  vertical: 'top',
                                                  horizontal: 'center',
                                              }}
                                              transformOrigin={{
                                                  vertical: 'bottom',
                                                  horizontal: 'center',
                                              }}
                                          >
                                              <Box p={1} className="contact-popover">
                                                  <Box>
                                                      <label>Phone:</label>
                                                      {this.state.currentcontactItem['custom:phone'] ||
                            ' (Not provided yet)'}
                                                  </Box>
                                                  <Box>
                                                      <label>Email:</label>
                                                      {this.state.currentcontactItem.email}
                                                  </Box>
                                              </Box>
                                          </Popover>

                                          <Popover
                                              open={this.state.pop_chart_open}
                                              anchorEl={this.state.anchorEl}
                                              onClose={this.handleClose}
                                              className="contact-popover-outer"
                                              anchorOrigin={{
                                                  vertical: 'bottom',
                                                  horizontal: 'center',
                                              }}
                                              transformOrigin={{
                                                  vertical: 'top',
                                                  horizontal: 'center',
                                              }}
                                          >
                                              <Box className="chart-popover">
                                                  <Box className="chart-header" p={2}>
                          Chart for{' '}
                                                      {this.state.currentSelectedPhysician
                                                          ? this.state.currentSelectedPhysician.lastName +
                            ' ' +
                            this.state.currentSelectedPhysician.firstName
                                                          : ''}
                                                  </Box>
                                                  <Box className="chart-box" px={2} pb={2}>
                                                      {this.state.pop_chart_open
                                                          ? this.getChartType(this.state.chartType)
                                                          : null}
                                                  </Box>
                                              </Box>
                                          </Popover>
                                      </TableBody>
                                  </Table>
                              </InfiniteScroll>
                          </TableContainer>
                      </Paper>
                  </Grid>
                  <div className='alert-section'>            
                      {' '}
                      {this.state.openPopup ? (
                          <Snackbar
                              anchorOrigin={{
                                  vertical: 'top',
                                  horizontal: 'center'
                              }}
                 
                              open={true}
                              onClose={this.handlePopupClose}
                          >
                              {this.state.openPopup ? (
                                  <Alert variant="filled"
                                      severity="success" onClose={this.handlePopupClose}>
                                      {this.state.successMessage}
                                  </Alert>
                              ) : null}
                          </Snackbar>
                      ) : null}
                  </div>

              </Grid>
            
          </>
      );
  }
}

export default withRouter(inject('centralStore')(observer(ClientListsDetails)));
